import { render, staticRenderFns } from "./QuestionTypeYoutubeLink.vue?vue&type=template&id=b1c194fe"
import script from "./QuestionTypeYoutubeLink.vue?vue&type=script&lang=js"
export * from "./QuestionTypeYoutubeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports